"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Dec 05 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomáš Leity
 */


var SimulatedKpiValueDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SimulatedKpiValueDTOConverter, _DataObjectConverter_);

  function SimulatedKpiValueDTOConverter() {
    _classCallCheck(this, SimulatedKpiValueDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedKpiValueDTOConverter).apply(this, arguments));
  }

  return SimulatedKpiValueDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SimulatedKpiValueDTOConverter = SimulatedKpiValueDTOConverter;